import { NgClass, NgIf } from '@angular/common';
import { Input, Component } from '@angular/core';
import type { CoreOrchestratorViewModelInterface } from '@nts/std/interfaces';

@Component({
    selector: 'nts-messages-area-container',
    templateUrl: './messages-area-container.component.html',
    styleUrls: ['./messages-area-container.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        NgClass
    ]
})
export class MessagesAreaContainerComponent {

    @Input() orchestratorViewModel: CoreOrchestratorViewModelInterface;
    @Input() viewModelLoaded: boolean;
}
